import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import { COUNTRIES, flagEmoji } from '../../data/countries';

export default function CountrySelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const rootRef = useRef(null);
  const searchRef = useRef(null);

  const current = COUNTRIES.find((c) => c.iso2 === value) || COUNTRIES.find((c) => c.iso2 === 'MG');

  useEffect(() => {
    const onClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  useEffect(() => {
    if (open) {
      setQuery('');
      setTimeout(() => searchRef.current?.focus(), 50);
    }
  }, [open]);

  const filtered = COUNTRIES.filter((c) => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return c.name.toLowerCase().includes(q) || c.dialCode.includes(q);
  });

  return (
    <div className="relative shrink-0" ref={rootRef}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 h-full px-3 border-r border-white/20 text-white/90 text-sm font-medium rounded-l-xl hover:bg-white/5 transition-colors"
      >
        <span className="text-base leading-none">{flagEmoji(current.iso2)}</span>
        {current.dialCode}
        <ChevronDown className="h-3.5 w-3.5 text-white/50" />
      </button>

      {open && (
        <div className="absolute z-20 top-full left-0 mt-2 w-72 max-h-80 bg-slate-900 border border-white/20 rounded-xl shadow-2xl flex flex-col overflow-hidden animate-scale-in">
          <div className="flex items-center gap-2 px-3 py-2.5 border-b border-white/10">
            <Search className="h-4 w-4 text-blue-300/50 shrink-0" />
            <input
              ref={searchRef}
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Rechercher un pays..."
              className="w-full bg-transparent text-white text-sm placeholder-blue-300/40 focus:outline-none"
            />
          </div>
          <div className="overflow-y-auto">
            {filtered.length === 0 ? (
              <div className="px-3 py-4 text-center text-blue-300/40 text-xs">Aucun pays trouvé</div>
            ) : (
              filtered.map((c) => (
                <button
                  key={c.iso2}
                  type="button"
                  onClick={() => { onChange(c.iso2); setOpen(false); }}
                  className={`w-full flex items-center gap-2.5 px-3 py-2 text-left text-sm transition-colors hover:bg-white/10 ${c.iso2 === current.iso2 ? 'bg-blue-500/15 text-blue-200' : 'text-white/85'}`}
                >
                  <span className="text-base leading-none">{flagEmoji(c.iso2)}</span>
                  <span className="flex-1 truncate">{c.name}</span>
                  <span className="text-blue-300/50 text-xs">{c.dialCode}</span>
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
